export default {
    namespaced: true,
    state: {
        acceptedFamiliesQuantity: null
    },
    getters: {
        getAcceptedFamiliesQuantity (state) {
            return state.acceptedFamiliesQuantity;
        }
    },
    mutations: {
        setAcceptedFamiliesQuantity (state, data) {
            state.acceptedFamiliesQuantity = data;
        }
    },
    actions: {}
};
